import axios from 'axios';
import http from "@/http-common";
import utility from "@/util/utility";

const API_URL = utility.URL_SAVE+utility.URL_BASE+':8080/api/auth/';

class AuthService {
    login(user) {
        return axios
            .post(API_URL + 'signin', {
                personalnummer: user.personalnummer,
                password: user.password
            })
            .then(response => {
                let user = response.data
                user.loginTime = new Date()
                if (response.data.accessToken) {
                    localStorage.setItem('user', JSON.stringify(user));
                }
                return user;
            });
    }
    logout() {
        localStorage.removeItem('user');
        localStorage.removeItem('companyData');
    }

    register(user) {
        return axios.post(API_URL + 'signup', {
            personalnummer: user.personalnummer,
            anrede: user.anrede,
            vorname: user.vorname,
            nachname: user.nachname,
            kst: user.kst,
            kstName: user.kstName,
            postingArea: user.postingArea,
            email: user.email,
            segment: user.segment,
            beschaeftigungsart: user.beschaeftigungsart,
            abteilung: user.abteilung,
            password: user.password,
            token: user.token,
        });
    }


    resetPWDCheck(data) {
        return axios.post(API_URL + 'reset-pwd/check', {
            email: data.email,
        });
    }

    resetPWD(email, userID) {
        return axios.post(API_URL + 'reset-pwd/reset', {
            email: email,
            userId: userID,
        });
    }

    getResetPWDuserData(token){
        return http.get('auth/reset/pwd/userdata',{params:{token}});
    }

    setNewPWD(data){
        return http.post(`/auth/set/pwd`,data);
    }

    getRegistrationData(token) {
        return http.get(`auth/register/companyData`,{params:{token},validateStatus: () => true});
    }
}

export default new AuthService();